<template>
  <div class="detail-page">
    <div class="" style="height: 65px; width: 100%; background-color: #000; position: fixed; z-index: 10;">
      
    </div> 
    <!-- 头部信息区 -->
    <section class="hero">
      <div class="hero__cover"
        style="background-image:url('https://images.unsplash.com/photo-1520975714660-1f8b7bcd0c90?q=80&w=1800&auto=format&fit=crop');">
      </div>
      <div class="hero__mask"></div>
      <div class="hero__content container">
        <div class="hero__card">
          <div class="cover"
            :style="{backgroundImage:`url(${shuben.image})`}">
          </div>
          <div class="info">
            <h1 class="title">{{shuben.name}}</h1>
            <p class="meta">作者：{{ shuben.author }}</p>
            
            <p class="desc" style="color: #837f7f;">{{ shuben.sort_name_text }}</p>
            <p class="desc">{{shuben.content}}</p>
            <div class="actions">
              <div class="btn btn--primary" @click="guankan(0)"
              >
                开始阅读
              </div>

              
              <button class="btn btn--subtle" type="button" @click="ShouCang()">{{shuben.status==0?'收藏':'已收藏'}}</button>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 主体两栏布局 -->
    <div class="container layout">
      <main class="main">
        <!-- 简介 -->
        <section class="panel">
          <h2 class="panel__title">作品介绍</h2>
          <div class="content">
            <p>{{shuben.content}}</p>
          </div>
        </section>

        <!-- 目录（静态示意） -->
        <section class="panel">
          <h2 class="panel__title">章节目录</h2>
          <div class="chapters">
            <div 
              class="chapter" 
              @click="guankan(index)"
              v-for="(item,index) in shuben.last_huashu" :key="index"
            >
              第{{index+1}}话 · {{shuben.name}}
              <span v-show="index+1>=shuben.first_free_huashu && shuben.first_free_huashu!==0" 
               :style="{
                  color: shuben.purchased_huashu_list.some(u => u == index + 1) ? '#ff3d00' : '#a9a9a9',
                  'font-size': '13px',
                  'position': 'absolute',
                  'right': '15px'
                }">
                {{shuben.purchased_huashu_list.some(u=>u==index+1)==true?'已解锁':'付费解锁'}}
              </span>
            </div>
            
          </div>
        </section>

        <!-- 猜你喜欢 -->
        <section class="panel">
          <h2 class="panel__title">猜你喜欢</h2>
          <div class="grid-like">
            <div class="like-card" v-for="(item,index) in CaiList" :key="index" @click="Xqing(item)">
              <div class="cover" 
              :style="{backgroundImage:`url(${ item.image})`}">
              </div>
              <div class="info">
                <h3 class="title">{{item.name}}</h3>
                <p class="meta">{{item.sort_name_text}}</p>
              </div>
            </div>
          </div>
        </section>
      </main>

      <!-- 侧边栏 -->
      <aside class="aside">
        <div class="side-card">
          <div class="rating">
            <div class="stars">
              <el-rate
                v-model="shuben.pingfeng"
                disabled
                show-score
                text-color="#ff9900"
                :score-template="String(shuben.pingfeng)">
              </el-rate>
            </div>
          </div>
          <ul class="meta-list">
            <li><span>篇幅</span><b>{{shuben.last_huashu}}+</b></li>
            <li><span>适龄</span><b>{{shuben.nianling}}</b></li>
            <li><span>人气</span><b>1,245,301</b></li>
          </ul>
          <div class="side-actions">
            <!-- <button class="btn btn--primary" type="button">追更</button> -->
            <!-- <button class="btn btn--ghost" type="button">下载封面</button> -->
          </div>
        </div>

        <div class="side-card">
          <h3 class="side-title">标签</h3>
          <div class="tags">
            {{shuben.sort_name_text}}
          </div>
        </div>
      </aside>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: 'XingQingM',
  data(){
    return{
      shuben:{},//漫画的详情
      CaiList:[],//猜你喜欢
    }
  },
  mounted(){
    this.Qing(this.$route.params.name)
  },
  methods:{
    Qing(name){
      let data = {
        name:name,
        yhname:this.$store.state.dlMark !== null? this.$store.state.dlMark.username : 'null'
      }
      axios.post('/api/index/sortdetail',data)
      .then(res=>{
        console.log(res.data.data);
        this.shuben = res.data.data;
      }).catch(err=>{
        console.log(err);
      })
      axios.post('/api/index/tuijian')
      .then(res=>{
        console.log(res.data.data)
        this.CaiList = res.data.data;
      }).catch(err=>{
        console.log(err);
      })
    },
    Xqing(item){
      console.log(item);
      this.$router.push({
        name:'Nxiangqing',
        params:{
          name:item.name
        }
      })
      this.Qing(this.$route.params.name);
    },
    //浏览页
    guankan(index){
      this.$router.push({
          name:'Nbrowse',
          params:{
            Mid:this.shuben.id,
            Hid:index+1
          }
      });
      localStorage.removeItem('FeeXiugai');
      localStorage.setItem('FeeXiugai',this.shuben.purchased_huashu_list);
    },
    ShouCang(){
      if(this.$store.state.dlMark!==null){
        let data = {
          yhname:this.$store.state.dlMark.username,
          comicid:this.shuben.id
        }
        axios.post('/api/index/comicsc',data).then(res=>{
          if(res.data.code==1){
            this.shuben.status = 1;
            this.$message.success('收藏成功！');
          }else{
            this.$message.warning('请勿重复点击');
          }
        }).catch(err=>{
          console.log(err);
        });
      }else{
        this.$message.warning('请登录后继续操作！')
      }
      
    }
  }
}
</script>

<style scoped>
.detail-page {
  color: #0f172a;
  /* background: #f8fafc; */
  min-height: 100vh;
  position: relative;
}

.container {
  max-width: 1300px;
  margin: 0 auto;
  padding: 0 16px;
}

/* Breadcrumbs */
.breadcrumbs {
  display: flex;
  gap: 8px;
  align-items: center;
  padding: 14px 16px;
  font-size: 13px;
  color: #475569;
}

.breadcrumbs a {
  color: #2563eb;
  text-decoration: none;
}

.breadcrumbs .current {
  color: #0f172a;
  opacity: .9;
}

/* Hero */
.hero {
  position: relative;
  padding-bottom: 32px;
}

.hero__cover {
  position: absolute;
  inset: 0 0 auto 0;
  height: 260px;
  background-size: cover;
  background-position: center;
  filter: saturate(1.05) contrast(1.02);
}

.hero__mask {
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(255, 255, 255, .25), rgba(248, 250, 252, .9) 60%, #f8fafc);
}

.hero__content {
  position: relative;
  padding-top: 90px;
}

.hero__card {
  display: grid;
  grid-template-columns: 180px 1fr;
  gap: 18px;
  padding: 16px;
  background: #ffffff;
  border: 1px solid rgba(15, 23, 42, .08);
  border-radius: 16px;
  backdrop-filter: blur(4px);
}

@media (max-width: 720px) {
  .hero__card {
    grid-template-columns: 1fr;
  }
}

.hero .cover {
  width: 100%;
  aspect-ratio: 3/4;
  background-size: cover;
  background-position: center;
  border-radius: 12px;
  box-shadow: 0 12px 30px rgba(2, 8, 23, .4);
}

.hero .info {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.hero .title {
  margin: 4px 0 0;
  font-size: 28px;
  color: #0f172a;
}

.hero .meta {
  margin: 0;
  opacity: .9;
  color: #2563eb;
}

.hero .desc {
  margin: 6px 0 0;
  line-height: 1.75;
  color: #334155;
  opacity: .95;
}

.actions {
  display: flex;
  gap: 10px;
  margin-top: 8px;
  flex-wrap: wrap;
  
  a {
    text-decoration: none;
  }
}

.btn {
  height: 40px;
  line-height: 40px;
  padding: 0 14px;
  border-radius: 12px;
  border: 1px solid transparent;
  background: rgba(148, 163, 184, .12);
  color: #0f172a;
  cursor: pointer;
  font-weight: 600;
  transition: transform .15s, box-shadow .15s, background .2s, border .2s;
}

.btn--primary {
  color: #1d1d1d;
  background: rgba(147, 197, 253, .08);
  border-color: rgba(147, 197, 253, .25);
}

.btn--primary:hover {
  color: #ffffff;
  transform: translateY(-1px);
  background: linear-gradient(135deg, #15b0c8, #1ebd58);
  

  box-shadow: 0 14px 30px rgba(34, 197, 94, .3);
}

.btn--ghost {
  background: rgba(148, 163, 184, .08);
  border-color: rgba(148, 163, 184, .25);
}

.btn--ghost:hover { 
  transform: translateY(-1px);
  color: #fff;
  background: linear-gradient(135deg, #22d3ee, #22c55e);
  box-shadow: 0 14px 30px rgba(34, 197, 94, .3);
}

.btn--subtle {
  background: rgba(147, 197, 253, .08);
  border-color: rgba(147, 197, 253, .25);
  color: #393939;
}

.btn--subtle:hover {
  transform: translateY(-1px);
  color: #fff;
  background: linear-gradient(135deg, #22d3ee, #22c55e);
  box-shadow: 0 14px 30px rgba(34, 197, 94, .3);
}

/* Layout */
.layout {
  display: grid;
  grid-template-columns: 1fr 320px;
  gap: 18px;
  padding: 16px;
}

@media (max-width: 1024px) {
  .layout {
    grid-template-columns: 1fr;
  }
}

/* Panel */
.panel {
  background: #ffffff;
  border: 1px solid rgba(15, 23, 42, .08);
  border-radius: 16px;
  padding: 16px;
}

.panel+.panel {
  margin-top: 16px;
}

.panel__title {
  margin: 0 0 10px;
  font-size: 18px;
  color: #0f172a;
}

.content p {
  margin: 10px 0;
  color: #334155;
  opacity: .95;
  text-align: justify;
}

/* Chapters */
.chapters {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}

@media (max-width: 640px) {
  .chapters {
    grid-template-columns: 1fr;
  }
}

.chapter {
  display: block;
  padding: 12px 14px;
  border-radius: 12px;
  color: #0f172a;
  text-decoration: none;
  background: rgba(148, 163, 184, .12);
  border: 1px solid rgba(15, 23, 42, .08);
  transition: transform .15s, background .2s, border .2s;
  cursor: pointer;
  position: relative;
}

.chapter:hover {
  transform: translateY(-2px);
  background: rgba(148, 163, 184, .18);
  border-color: rgba(15, 23, 42, .18);
}

/* Like grid */
.grid-like {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;
}

@media (max-width: 1100px) {
  .grid-like {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 768px) {
  .grid-like {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 520px) {
  .grid-like {
    grid-template-columns: 1fr;
  }
}

.like-card {
  display: block;
  border-radius: 14px;
  overflow: hidden;
  border: 1px solid rgba(15, 23, 42, .08);
  background: #ffffff;
  text-decoration: none;
  transition: transform .2s, box-shadow .2s, border .2s;
}

.like-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 18px 36px rgba(2, 8, 23, .12);
  border-color: rgba(15, 23, 42, .18);
}

.like-card .cover {
  aspect-ratio: 3/4;
  background-size: cover;
  background-position: center;
}

.like-card .info {
  padding: 10px 12px 12px;
}

.like-card .title {
  margin: 0 0 4px;
  color: #0f172a;
  font-size: 15px;
}

.like-card .meta {
  margin: 0;
  opacity: .8;
  font-size: 12px;
  color: #64748b;
}

/* Aside */
.aside {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.side-card {
  background: #ffffff;
  border: 1px solid rgba(15, 23, 42, .08);
  border-radius: 16px;
  padding: 16px;
}

.sticky {
  position: sticky;
  top: 14px;
}

.rating {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.stars span {
  color: #fde68a;
  margin-right: 2px;
}

.stars .dim {
  color: #cbd5e1;
}

.score {
  font-size: 22px;
  font-weight: 700;
  color: #0f172a;
}

.meta-list {
  list-style: none;
  margin: 10px 0 14px;
  padding: 0;
  display: grid;
  gap: 8px;
}

.meta-list li {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  color: #64748b;
}

.meta-list b {
  color: #0f172a;
  font-weight: 600;
}

.side-actions {
  display: flex;
  gap: 10px;
}

.side-title {
  margin: 0 0 10px;
  color: #0f172a;
  font-size: 16px;
}

.tags {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  color: #929292;
}

.tag {
  color: #2563eb;
  background: rgba(37, 99, 235, .08);
  border: 1px solid rgba(37, 99, 235, .22);
  padding: 6px 10px;
  border-radius: 999px;
  font-size: 12px;
}

/* 小动画 */
@keyframes floaty {
  from {
    transform: translateY(0px);
  }

  50% {
    transform: translateY(-2px);
  }

  to {
    transform: translateY(0px);
  }
}

.btn--subtle,
.tag:nth-child(2n) {
  animation: floaty 5s ease-in-out infinite;
}
</style>
